const topics = [
  { name: '暑期档电影', hot: '2.3w', color: 'bg-primary-100 text-primary-700' },
  { name: '科幻片推荐', hot: '1.8w', color: 'bg-accent-100 text-accent-700' },
  { name: '高分韩剧', hot: '1.6w', color: 'bg-secondary-100 text-secondary-700' },
  { name: '国产动画', hot: '1.5w', color: 'bg-primary-100 text-primary-700' },
  { name: '悬疑推理', hot: '1.3w', color: 'bg-accent-100 text-accent-700' },
  { name: '纪录片精选', hot: '1.1w', color: 'bg-secondary-100 text-secondary-700' },
  { name: '经典港片', hot: '9.8k', color: 'bg-primary-100 text-primary-700' },
  { name: '4K超清', hot: '8.5k', color: 'bg-accent-100 text-accent-700' },
  { name: '治愈系动漫', hot: '7.2k', color: 'bg-secondary-100 text-secondary-700' },
  { name: 'Netflix精选', hot: '6.6k', color: 'bg-primary-100 text-primary-700' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-3 whitespace-nowrap">
            热门话题
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            全网热议 · 大家都在聊
          </h2>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((t, i) => (
            <span
              key={i}
              className={`cursor-pointer inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium ${t.color} hover:opacity-80 transition-opacity whitespace-nowrap`}
            >
              <span className="text-xs">#</span>
              {t.name}
              <span className="text-[10px] opacity-60 ml-1">{t.hot}</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}